
import { DateTime } from 'luxon';
import { Component, Prop, Vue } from 'vue-property-decorator';

// Components
import { VGridCol, VGridRow } from 'vui';
import VDateCreator from '../VDate/VDateCreator.vue';
import VDateViewer from '../VDate/VDateViewer.vue';

@Component({
    components: {
        VGridRow,
        VGridCol,
        VDateViewer,
        VDateCreator,
    },
})
export default class SelectorDate extends Vue {
    @Prop({ type: Boolean, default: false })
    public isCreateViolation!: boolean;

    @Prop({ type: String, default: '' })
    public deadline!: string;

    @Prop({ type: String, default: '' })
    public createdAt!: string;

    @Prop({ type: Boolean, default: false })
    public isEditingAllow!: boolean;

    get deadlineMin() {
        let deadlineMin = this.deadline ? this.deadline : '';
        const tomorrow = DateTime.now().plus({ days: 1 }).toFormat('yyyy-MM-dd');
        if (deadlineMin < tomorrow) deadlineMin = tomorrow;

        return deadlineMin;
    }

    public setSelectedDeadline(deadline: string) {
        this.$emit('setSelectedDeadline', deadline);
    }
}
